import { LucideIcon } from "@ews-admin/global-design-system";
import React from "react";

interface ActivityCardProps {
  title: string;
  description: string;
  time: string;
  icon: LucideIcon;
  iconColor?: string;
  iconBgColor?: string;
  className?: string;
}

export const ActivityCard: React.FC<ActivityCardProps> = ({
  title,
  description,
  time,
  icon: Icon,
  iconColor = "text-primary-600",
  iconBgColor = "bg-ews-primary-100",
  className = "",
}) => {
  return (
    <div
      className={`flex items-start space-x-3 p-3 rounded-lg hover:bg-neutral-50 transition-all duration-200 hover-lift ${className}`}
    >
      <div
        className={`flex-shrink-0 w-8 h-8 rounded-lg flex items-center justify-center hover-scale ${iconBgColor}`}
      >
        <Icon className={`w-4 h-4 ${iconColor}`} />
      </div>
      <div className="flex-1 min-w-0">
        <p className="text-xs font-medium text-neutral-900 mb-1">{title}</p>
        <p className="text-xs text-neutral-600 mb-1">{description}</p>
        <p className="text-xs text-neutral-400">{time}</p>
      </div>
    </div>
  );
};
